import { api } from "@/lib/api/axios";
import type { RegionId, WorkflowId } from "@/lib/tci";

export type TciFunnelStep =
  | "intro"
  | "workflow"
  | "calculator_1"
  | "calculator_2"
  | "calculator_3"
  | "report_ready"
  | "results"
  | "booking";

export type CreateTciSessionPayload = {
  anonymousId: string;
  landingPath?: string;
  referrer?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;
  userAgent?: string;
};

export type CreateTciSessionResponse = {
  id: string;
  anonymousId: string;
  status: string;
};

export type UpdateTciSessionPayload = {
  currentStep?: TciFunnelStep;
  lastEvent?: string;
  workflowId?: WorkflowId;
  regionId?: RegionId | null;
  businessSector?: string | null;
  organisationName?: string | null;
  laborHeadcount?: number;
  laborTimePercent?: number;
  laborSalary?: number;
  yieldVolume?: number;
  yieldPenaltyPerEvent?: number;
  untappedVolume?: number;
  untappedActionablePercent?: number;
  untappedValuePerAction?: number;
  annualEbitda?: number;
  email?: string;
  consent?: boolean;
  laborWaste?: number;
  yieldPenaltyWaste?: number;
  untappedValue?: number;
  totalTrapped?: number;
  tciScore?: number | null;
  bandId?: string | null;
  bandLabel?: string | null;
};

export async function createTciSession(
  payload: CreateTciSessionPayload,
): Promise<CreateTciSessionResponse> {
  const { data } = await api.post<CreateTciSessionResponse>(
    "/tci-sessions",
    payload,
  );
  return data;
}

export async function updateTciSession(
  sessionId: string,
  payload: UpdateTciSessionPayload,
): Promise<void> {
  await api.patch(`/tci-sessions/${sessionId}`, payload);
}
